<template>
    <Loading 
      
      :active.sync="loader" 
      :is-full-page="true"
      background-color="#074d3f"
      color="#005a16 "
      :lock-scroll="true"
      :opacity=0.5
      :height=128
      :width=128>
      </Loading>
</template>

<script>

import Loading  from 'vue-loading-overlay'
import { mapState } from 'vuex'
    export default {
        components: {
            Loading
        },
        computed: {
            ...mapState('reservav2', ['loader'])
        },
    }
</script>

<style lang="scss" scoped>

</style>